import type { Localization } from '@vue-pdf-viewer/viewer'
import { useI18n } from 'vue-i18n'
import { computed, ComputedRef } from 'vue'

export function useLocalization(): ComputedRef<Partial<Localization>> {
  const $i18n = useI18n()

  return computed(() => ({
    zoomInTooltip: $i18n.t('pdf.zoomInTooltip'),
    zoomOutTooltip: $i18n.t('pdf.zoomOutTooltip'),
    zoomPageFit: $i18n.t('pdf.zoomPageFit'),
    zoomPageWidth: $i18n.t('pdf.zoomPageWidth'),
    zoomActualSize: $i18n.t('pdf.zoomActualSize'),
    zoomSelectTooltip: $i18n.t('pdf.zoomSelectTooltip'),
    commentPanelTooltip: $i18n.t('pdf.commentPanelTooltip'),
    nextPageTooltip: $i18n.t('pdf.nextPageTooltip'),
    previousPageTooltip: $i18n.t('pdf.previousPageTooltip'),
    searchInputTooltip: $i18n.t('pdf.searchInputTooltip'),
    searchButtonTooltip: $i18n.t('pdf.searchButtonTooltip'),
    searchNextTooltip: $i18n.t('pdf.searchNextTooltip'),
    searchPrevTooltip: $i18n.t('pdf.searchPrevTooltip'),
    searchMatchCaseTooltip: $i18n.t('pdf.searchMatchCaseTooltip'),
    searchWholeWordsTooltip: $i18n.t('pdf.searchWholeWordsTooltip'),
    searchMatchCaseLabel: $i18n.t('pdf.searchMatchCaseLabel'),
    searchWholeWordsLabel: $i18n.t('pdf.searchWholeWordsLabel'),
    searchInputPlaceholder: $i18n.t('pdf.searchInputPlaceholder'),
    searchCloseButtonTooltip: $i18n.t('pdf.searchCloseButtonTooltip')
  }))
}
